import { UpdatedResultDto } from './updated-result-dto';

export class PointOfSaleTransactionRawDto extends UpdatedResultDto {
    pointOfSaleTransactionID: number;
    transactionReferenceType: string;
    transactionReferenceID: number;
    originationTransactionType: string;
    originationTransactionID: number;
}
